module.exports = __webpack_public_path__ + "static/media/img3.c91d9064.png";